import { render } from "./ThreeDModelView.vue?vue&type=template&id=7605cf56&scoped=true"
import script from "./ThreeDModelView.vue?vue&type=script&lang=js"
export * from "./ThreeDModelView.vue?vue&type=script&lang=js"

import "./ThreeDModelView.vue?vue&type=style&index=0&id=7605cf56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7605cf56"]])

export default __exports__